// am4core.useTheme(am4themes_animated);

angular.module('app')
    .directive("amcharts", ['$rootScope', '$window', '$timeout', function ($rootScope, $window, $timeout) {
        return {
            restrict: "E",
            scope: {
                data: '=',
            },
            template: "<div id='chartdiv'></div>",
            replace: true,
            link: function ($scope) {
                var chart = am4core.create("chartdiv", am4charts.XYChart);


                setLang($rootScope.LANG)

                chart.paddingRight = 20;

                chart.data = [];

                var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
                dateAxis.renderer.grid.template.location = 0;
                dateAxis.tooltipDateFormat = "d MMMM yyyy, HH:mm";

                var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.tooltip.disabled = true;
                valueAxis.renderer.minWidth = 35;

                var series_product_height = chart.series.push(new am4charts.LineSeries());
                series_product_height.dataFields.dateX = "date";
                series_product_height.dataFields.valueY = "product_height";
                series_product_height.tooltipText = "{valueY.product_height}";
                series_product_height.fillOpacity = .4;

                var series_high_product_alarm_height = chart.series.push(new am4charts.LineSeries());
                series_high_product_alarm_height.dataFields.dateX = "date";
                series_high_product_alarm_height.dataFields.valueY = "high_product_alarm_height";
                series_high_product_alarm_height.tooltipText = "{valueY.high_product_alarm_height}";
                series_high_product_alarm_height.stroke = "#CDA2AB";
                series_high_product_alarm_height.strokeWidth = 1;

                var series_low_product_alarm_height = chart.series.push(new am4charts.LineSeries());
                series_low_product_alarm_height.dataFields.dateX = "date";
                series_low_product_alarm_height.dataFields.valueY = "low_product_alarm_height";
                series_low_product_alarm_height.tooltipText = "{valueY.low_product_alarm_height}";
                series_low_product_alarm_height.stroke = "#CDA2AB";
                series_low_product_alarm_height.strokeWidth = 1;

                var series_critical_high_product_alarm_height = chart.series.push(new am4charts.LineSeries());
                series_critical_high_product_alarm_height.dataFields.dateX = "date";
                series_critical_high_product_alarm_height.dataFields.valueY = "critical_high_product_alarm_height";
                series_critical_high_product_alarm_height.tooltipText = "{valueY.critical_high_product_alarm_height}";
                series_critical_high_product_alarm_height.stroke = 'red';
                series_critical_high_product_alarm_height.strokeWidth = 2;

                var series_critical_low_product_alarm_height = chart.series.push(new am4charts.LineSeries());
                series_critical_low_product_alarm_height.dataFields.dateX = "date";
                series_critical_low_product_alarm_height.dataFields.valueY = "critical_low_product_alarm_height";
                series_critical_low_product_alarm_height.tooltipText = "{valueY.critical_low_product_alarm_height}";
                series_critical_low_product_alarm_height.stroke = 'red';
                series_critical_low_product_alarm_height.strokeWidth = 2;


                // chart.guides = new am4charts.XYCursor();
                chart.cursor = new am4charts.XYCursor();


                $scope.$watch('data', function (newData) {
                    $scope.render(newData);
                }, true);
                $scope.render = function (data) {

                    if (!data) {
                        return;
                    }
                    var scrollbarX = new am4charts.XYChartScrollbar();
                    scrollbarX.series.push(series_product_height);
                    chart.scrollbarX = scrollbarX;
                    chart.data = data;
                }

                function setLang(lang) {
                    switch (lang) {
                        case 'en':
                            chart.language.locale = window.am4lang_en_US;
                            break;
                        case 'uk':
                            chart.language.locale = window.am4lang_uk_UA;
                            break;
                        case 'ru':
                            chart.language.locale = window.am4lang_ru_RU;
                            break;
                        case 'pl':
                            chart.language.locale = window.am4lang_pl_PL;
                            break;
                        case 'sk':
                            // todo добавить переводы
                            chart.language.locale = window.am4lang_en_US;
                            break;
                        case 'de':
                            chart.language.locale = window.am4lang_de_DE;
                            break;
                    }
                }

                $scope.$on("$destroy", function () {
                    chart.dispose();
                });

                $rootScope.$watch('LANG', function (newValue, oldValue) {
                    setLang(newValue);
                    $scope.render($scope.data);
                });
            }
        };
    }]);

